export const allowMaxCharLength = ({ name, length, setValue, value }) => {
  const englishNumberRegex = /^[0-9\b]*$/;

  const checkIsNumeric = englishNumberRegex.test(value);
  const checkIfValueHasMoreLength = value.length <= length;

  if (checkIsNumeric && checkIfValueHasMoreLength) {
    setValue(name, value);
  }
};
